import Redemption from './Redemption'
import { AccessType } from 'app/auth/accessControlService'

export const RedemptionConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: true,
        },
        toolbar: {
          display: true,
        },
        leftSidePanel: {
          display: true,
        },
      },
    },
  },
  routes: [
    {
      path: '/vouchers/redemption',
      component: Redemption,
      accesses: [
        AccessType.ADMINISTRATION,
        AccessType.NOTIFICATION_VIEW_OWNED,
        AccessType.NOTIFICATION_VIEW_ALL,
        AccessType.SUBSCRIBER_VIEW,
      ],
    },
  ],
}
